import { useContext } from 'react';

import { HistogramFilteredDataContext } from '../contexts/HistogramFilteredData.context.js';

export const useHistogramFilteredData = () =>
  useContext(HistogramFilteredDataContext);
